import { render, staticRenderFns } from "./controlArea.vue?vue&type=template&id=442068fb&scoped=true&"
import script from "./controlArea.vue?vue&type=script&lang=js&"
export * from "./controlArea.vue?vue&type=script&lang=js&"
import style0 from "./controlArea.vue?vue&type=style&index=0&id=442068fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442068fb",
  null
  
)

export default component.exports